import { useQuery } from '@tanstack/react-query';

import { nationalitiesApi } from '@/services';

const STALE_TIME = 5 * 60 * 1000;

export const nationalitiesKeys = {
  report: () => ['reports', 'nationalities'] as const,
};

export function useNationalityReportQuery() {
  return useQuery({
    queryKey: nationalitiesKeys.report(),
    queryFn: () => nationalitiesApi.getReport(),
    staleTime: STALE_TIME,
  });
}
